// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
export default slotShouldForwardProp;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/slotShouldForwardProp.js
// module id = 385
// module chunks = 22